const unSentMessages = (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_NEW_MESSAGE_EDITOR_STATE':
      return {
        ...state,
        [action.conversationObjId]: {
          ...state[action.conversationObjId],
          editorState: action.editorState,
          decisionTreeCouponCode: action.decisionTreeCouponCode,
        },
      };

    case 'CLEAR_UNSENT_MESSAGE':
      let newState = {
        ...state,
      };
      delete newState[action.conversationObjId];

      return newState;

    case 'SET_NEW_MESSAGE_COUPON_CODE_TYPE':
      return {
        ...state,
        [action.conversationObjId]: {
          ...state[action.conversationObjId],
          macroCouponCodeTypeId: action.macroCouponCodeTypeId,
        },
      };

    default:
      return state;
  }
};

export default unSentMessages;
